/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import JwtDecode from 'jwt-decode';

const env = document.querySelector<HTMLElement>('[data-env]')!.dataset.env!;
const authenticationFrame = document.createElement('iframe');
authenticationFrame.id = 'authenticationFrame';
authenticationFrame.title = 'authentication Frame';
authenticationFrame.src = `${env}html/authentication.html`;
authenticationFrame.style.display = 'none';
authenticationFrame.onload = () => {
    authenticationFrame.contentWindow!.postMessage({ type: 'connexion' }, env);
};
document.body.appendChild(authenticationFrame);

function clear() {
    token =
        userRole =
        userName =
        language =
        dossierNumber =
        dossierId =
        displayName =
            undefined;
}

const changeHandlers = new Set<() => void>();
function triggerChange() {
    changeHandlers.forEach((cb) => cb());
}

window.addEventListener('message', function (e) {
    if (typeof e.data === 'string') {
        const [type, ...payload] = e.data.split(':');
        let data = payload.join(':');
        switch (type) {
            case 'connexionFrame':
                authenticationFrame.contentWindow!.postMessage(
                    { type: 'auth' },
                    env
                );
                break;

            case 'authFrame':
            case 'checkRenewFrame':
                if (data === 'logout') {
                    data = '';
                }

                // eslint-disable-next-line no-case-declarations
                const message = JSON.parse(data || 'null');
                if (message && message.token) {
                    displayName = message.displayName;
                    language = message.langue;
                    const jwtPayload = JwtDecode<any>(message.token);
                    token = message.token;
                    userName =
                        jwtPayload[
                            'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'
                        ];
                    userRole =
                        jwtPayload[
                            'http://schemas.microsoft.com/ws/2008/06/identity/claims/role'
                        ];
                    dossierId = +jwtPayload['dossierUnique/ExterneID'];
                    dossierNumber = jwtPayload['dossierUnique/NumDossier'];
                    exp = jwtPayload.exp * 1000;
                    clearTimeout(renewTimer);
                    const now = new Date().getTime();
                    renewTimer = window.setTimeout(
                        () => {
                            if (exp > new Date().getTime()) {
                                authenticationFrame.contentWindow!.postMessage(
                                    { type: 'renew' },
                                    env
                                );
                            } else {
                                clear();
                            }
                        },
                        exp - now - 5 * 60 * 1000
                    );
                } else {
                    clear();
                }

                triggerChange();
                break;
        }
    }
});

let displayName: string | undefined,
    dossierId: number | undefined,
    dossierNumber: string | undefined,
    language: string | undefined,
    userName: string | undefined,
    userRole: string | undefined,
    token: string | undefined,
    exp: number,
    renewTimer: number;
export const SecurityApiService = {
    get displayName() {
        return displayName;
    },

    get dossierId() {
        return dossierId;
    },

    get dossierNumber() {
        return dossierNumber;
    },

    get language() {
        return language;
    },

    get userName() {
        return userName;
    },

    get userRole() {
        return userRole;
    },

    get token() {
        return token;
    },

    addOnChangeListener(callback: () => void) {
        changeHandlers.add(callback);
    },

    removeOnChangeListener(callback: () => void) {
        changeHandlers.delete(callback);
    },

    hasAccessToBasketOffer(): boolean {
        return (
            this.isTokenValid() &&
            this.isRoleValid() &&
            dossierId != undefined &&
            dossierId != 0
        );
    },

    isTokenValid(): boolean {
        if (!token) {
            return false;
        }

        return exp > new Date().getTime();
    },

    isRoleValid(): boolean {
        if (!userRole) {
            return false;
        }

        const role = userRole.toUpperCase();

        return role == 'JOBSEEKER' || role == 'INDIVIDUAL';
    },
};
